import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import axios from "api/axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PageShell, { SectionCard } from "components/patch/PageShell";

const money = (v) =>
  Number(v || 0).toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function ManagementReports() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const res = await axios.get("/reports/management");
      setData(res.data?.data || {});
    } catch (err) {
      setError(err.response?.data?.message || "Unable to load management report.");
    }
  };

  useEffect(() => {
    load();
  }, []);

  const cards = [
    ["Total Staff", data?.staff?.total],
    ["Active Staff", data?.staff?.active],
    ["Inactive Staff", data?.staff?.inactive],
    ["Pending Variations", data?.pending_variations],
    ["Payroll Gross", money(data?.payroll?.total_gross)],
    ["Payroll Deductions", money(data?.payroll?.total_deductions)],
    ["Payroll Net", money(data?.payroll?.total_net)],
  ];

  return (
    <PageShell title="Management Reports" subtitle="Management payroll dashboard.">
      {error && <Alert severity="error">{error}</Alert>}

      <Grid container spacing={3}>
        {cards.map(([label, value]) => (
          <Grid item xs={12} sm={6} md={3} key={label}>
            <Card sx={{ borderRadius: 3 }}>
              <MDBox p={3}>
                <MDTypography variant="button" color="text">
                  {label}
                </MDTypography>
                <MDTypography variant="h4" fontWeight="bold">
                  {value || 0}
                </MDTypography>
              </MDBox>
            </Card>
          </Grid>
        ))}
      </Grid>

      <MDBox mt={3}>
        <SectionCard title="Recent Payroll Runs">
          {(data?.recent_runs || []).map((r) => (
            <MDTypography key={r.id} variant="button" display="block">
              {r.month} — {r.status || "N/A"} — {r.generation_status || "N/A"}
            </MDTypography>
          ))}
        </SectionCard>
      </MDBox>
    </PageShell>
  );
}
